import { render } from "./account_info.vue?vue&type=template&id=0cdb6eea"
import script from "./account_info.vue?vue&type=script&lang=js"
export * from "./account_info.vue?vue&type=script&lang=js"
script.render = render

export default script